import React from 'react';
import './PreviewImage.scss';
import BasePrompt from '../../base/prompt/BasePrompt';
function PreviewImage(props) {
  const extraClass = props.extraClass || {};
  return (
    <BasePrompt
      show={props.show}
      closeAction={props.onClose}
      title={'Preview'}
      otherBody={() => {
        return (
          <img
            src={props.imageUrl}
            style={{
              width: 315,
              height: 315 * 1.7,
              border: '1px solid #DADADA',
              objectFit: 'cover',
              marginTop: 18,
              ...extraClass,
            }}
          />
        );
      }}
    />
  );
}

export default PreviewImage;
